import React from "react";
import "./index.scss";
import Autocomplete from "devextreme-react/autocomplete";
import { IMdaeAutoCompleteProps } from "./index";
import { RequiredFieldLabel } from "../required-field-label";

const MdaeAutoComplete: React.FC<IMdaeAutoCompleteProps> = (props) => {
  return (
    <div
      className={"sys-mdae-autocomplete-date-picker-container"}
      style={{ position: "relative" }}
    >
      <Autocomplete {...props}></Autocomplete>
      {props.visible !== false && (
        <span
          className={
            typeof props.MdaeAutocompleteTitleComponent === "function"
              ? props.MdaeAutocompleteTitleComponentClassName
              : "mdae-text-box-field-set-text"
          }
        >
          {props.mdaeAutocompleteTitle}
          {typeof props.MdaeAutocompleteTitleComponent === "function" && (
            <props.MdaeAutocompleteTitleComponent></props.MdaeAutocompleteTitleComponent>
          )}
          {props.required && <RequiredFieldLabel />}
        </span>
      )}
    </div>
  );
};
export default MdaeAutoComplete;
